import { useMemo, useState } from 'react';

export const useSearchDataInitialiser = (search, routerData) => {
  const { query } = routerData;
  const [alsoSearched, setAlsoSearched] = useState(false);

  const {
    'search-term': term,
    sortBy,
    page = 1,
    originalSearchTerm = undefined,
    suggestion,
  } = query;

  return useMemo(
    () => ({
      ...search,
      term,
      sortBy,
      page,
      originalSearchTerm,
      alsoSearched,
      setAlsoSearched,
      isSuggestionLink: suggestion?.split(':')[0] === 'true',
    }),
    [term, sortBy, page, originalSearchTerm, suggestion, search, alsoSearched]
  );
};
